<template>

    <!-- FLEX BOX CONTAINER -->
    <div class="d-flex flex-row flex-wrap mb-2" v-if="subPanels && subPanels.length > 1">

        <!-- SELECT SUB PANELS -->
        <v-card v-for="subPanel in subPanels" :key="subPanel.id"
                class="mr-2"
                :color="color"
                height="48">

            <v-card-text class="pa-2">

                <div class="d-flex flex-row flex-wrap" v-if="subPanels && subPanels.length > 1">

                    <v-checkbox v-model="selectedModel"
                                class="mt-0"
                                :value="subPanel.id"
                                hide-details
                                @change="changed"
                                @click="clicked"
                                color="primary"
                    ></v-checkbox>

                    <div class="body-2 name">
                        {{ subPanel.name }}
                    </div>
                </div>
            </v-card-text>
        </v-card>

        <v-slide-x-transition>
            <v-btn v-show="rememberButtonVisible"
                   @click="rememberClicked"
                   text
                   class="align-self-center">Remember selection?
            </v-btn>
        </v-slide-x-transition>
    </div>

</template>

<script>

const LOCAL_STORAGE_KEY = 'SegmentBuilderSubPanelsDefault';

export default {

    props: {

        subPanels: {
            type: Array | null,
            required: true
        },

        selected: {
            type: Array | null,
            required: false,
        },

        color: {
            type: String,
            required: false,
            default: 'grey darken-4'
        }
    },

    watch: {
        selected() {
            this.loadPreviousSelections();
        },
        subPanels() {
            this.filterSubPanels();
        }
    },

    data() {
        return {
            selectedModel: [],
            rememberButtonVisible: false,
        }
    },

    methods: {

        clicked() {
            // Do not allow remembering empty
            if (this.selectedModel.length > 0) {
                this.rememberButtonVisible = true;
            }
        },

        rememberClicked() {
            localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(this.selectedModel));
            this.rememberButtonVisible = false;
        },

        changed() {
            this.$emit('change', [...this.selectedModel])
        },

        selectAll() {
            if (this.subPanels) {
                this.selectedModel = this.subPanels.map(subPanel => subPanel.id);
                this.changed();
            }
        },

        deselectAll() {
            this.selectedModel = [];
            this.changed();
        },

        switchChanged(switchOn) {
            if (switchOn) {
                this.selectAll();
            } else {
                this.deselectAll();
            }
        },

        loadPreviousSelections() {
            this.selectedModel = this.selected.filter(id => this.subPanels.map(sp => sp.id).includes(id));
        },

        filterSubPanels() {
            const selectedModel = localStorage.getItem(LOCAL_STORAGE_KEY);

            if (!this.selected || this.selected.length === 0) {
                this.selectAll();
            } else if (this.selected.length === 0 && selectedModel) {
                // Filter out any ids that may have been deleted
                const validSubPanelIds = this.subPanels.map(subPanel => subPanel.id);
                this.selectedModel = JSON.parse(selectedModel).filter(subPanelId => validSubPanelIds.includes(subPanelId));
                this.changed();
            } else {
                this.loadPreviousSelections();
            }
        }
    },

    mounted() {
        this.filterSubPanels();
    }
}
</script>

<style scoped>
.name {
    padding-top: 7px;
}
</style>
